import { FC, PropsWithChildren, ReactNode } from 'react';
import { Button } from '../ui/button';
import ArrowLeftIcon from '../icons/ArrowLeftIcon';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';
import { cn } from '@/lib/utils';

type Props = {
	title?: string;
	className?: string;
	addBackButton?: boolean;
	search?: ReactNode;
};

const EPageHeader: FC<PropsWithChildren<Props>> = ({
	title,
	className,
	children,
	addBackButton,
	search,
}) => {
	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);
	const navigate = useNavigate();

	return (
		<div className={cn('flex items-center gap-4 select-none', className)}>
			{addBackButton && (
				<Button
					variant='outline'
					size='icon'
					className='self-start'
					onClick={() => navigate(-1)}>
					<ArrowLeftIcon />
				</Button>
			)}
			<div
				className={cn(
					'w-full flex gap-4 select-none',
					isMobile ? 'flex-col' : '',
				)}>
				<div className='w-full flex justify-between items-center gap-4'>
					<h2
						className={cn(
							'text-2xl font-semibold',
							isMobile && 'text-lg font-medium',
						)}>
						{title}
					</h2>
					<div className={'w-fit flex justify-end gap-4'}>
						{!isMobile && <div>{search}</div>}
						{children}
					</div>
				</div>
				{isMobile && !!search && <div className='w-full'>{search}</div>}
			</div>
		</div>
	);
};

export default EPageHeader;
